import React, { useEffect, useState } from "react";

export function CheckBox(props) {
  const { daysCheck, handlecheckBox, viewModeOnly } = props;
  const [checkItems, setCheckItems] = useState([]);

  useEffect(() => {
    setCheckItems(daysCheck);
  }, [props.daysCheck]);
  function handleCheckSelection(item) {
    handlecheckBox(item);
  }
  return (
    <div className="row">
      {checkItems.map((item, index) => {
        return (
          <div className="col-4" key={index}>
            <input
              type="checkBox"
              id={item.day}
              name={item.day}
              disabled={viewModeOnly}
              defaultChecked={item.isChecked}
              onChange={() => {
                handleCheckSelection(item);
              }}
            />
            <label className="labelFont ml-1">{item.day}</label>
          </div>
        );
      })}
    </div>
  );
}
